import { IStaff } from './../../api/types/_staff';
import { createSlice } from "@reduxjs/toolkit";
import { getStaffs } from "./thunk";
import { PaginationResponse, ResponseData } from "api/types/_public";

export interface IState {
  staff: ResponseData<IStaff[]> & PaginationResponse | null,
  isStaffLoading: boolean,
  isStaffSuccess: boolean,

  error: any,
};

export const initialState: IState = {
  staff: null,
  isStaffLoading: false,
  isStaffSuccess: false,

  error: {},
};

const StaffSlice = createSlice({
  name: "staff",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getStaffs.pending, (state: IState, action: any) => {
      state.isStaffLoading = true
    });
    builder.addCase(getStaffs.fulfilled, (state: IState, action: any) => {
      state.staff = action.payload.data;
      state.isStaffSuccess = true;
      state.isStaffLoading = false;
    });
    builder.addCase(getStaffs.rejected, (state: IState, action: any) => {
      state.error = action.payload.error || null;
      state.isStaffSuccess = false;
      state.isStaffLoading = false;
    });
  },
});

export default StaffSlice.reducer;